import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0898d91c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full table-auto border-collapse" }
const _hoisted_2 = { class: "bg-gray-200" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Пункт", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Доп. услуга", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Город", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Кол-во", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Продолжительность", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "₸ / час (c НДС)", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Итого (с НДС)", -1))
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["FTLAdditionalServiceTable", { 'table--six': _ctx.isPaidPrice }])
  }, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        (!_ctx.isPaidPrice)
          ? (_openBlock(), _createElementBlock("th", _hoisted_6, "Поставщик"))
          : _createCommentVNode("", true),
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalService, (service, i) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: `service-${i}`
          }, [
            _createElementVNode("td", null, _toDisplayString(service.type_of_stock), 1),
            _createElementVNode("td", null, _toDisplayString(service.type_name), 1),
            _createElementVNode("td", null, _toDisplayString(service.city_name), 1),
            (!_ctx.isPaidPrice)
              ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(service.carrier_name) + " (" + _toDisplayString(service.cost_price_with_nds ? 'НДС включен' : 'НДС не включен') + ") ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("td", null, _toDisplayString(service.value), 1),
            _createElementVNode("td", null, [
              (_ctx.isPaidPrice)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(service.duration_client), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(service.duration), 1)
                  ], 64))
            ]),
            _createElementVNode("td", null, [
              (_ctx.isPaidPrice)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(service.paid_price_per_hour)), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(service.cost_per_hour)), 1)
                  ], 64))
            ]),
            _createElementVNode("td", null, [
              (_ctx.isPaidPrice)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(service.paid_price_total)), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(service.cost_total)), 1)
                  ], 64))
            ])
          ]))
        }), 128))
      ])
    ])
  ], 2))
}